'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';


export default [function() {
    return {
        restrict: 'A',
        template: require('../view/project-tab-progress.html'),
        scope: {
            project: '=myProject',
            edit: '=edit',
            chronology: '=myChronology',
        },
        controller: ['$scope',
                     function($scope) {
                         $scope.equals = equals;

                         function equals(a, b) {
                             return angular.equals(a, b);
                         }
                     }],
    };
}];
